import style from './style.css';

const WhiteLenders = () => {
  const lenderImages = [
    'https://iccdn.in/lenders/idfc-white-logo.svg',
    'https://iccdn.in/lenders/hdfc-white-logo.svg',
    'https://iccdn.in/lenders/kotak-white-logo.svg',
    'https://iccdn.in/lenders/icici-white-logo.svg',
    'https://iccdn.in/lenders/bob-white-logo.svg',
  ];
  return (
    <div className={style.lendersContainer}>
      {lenderImages.map((eachImage) => {
        return (
          <div>
            <img src={eachImage} className={style.lenderImage} alt='logo' />
          </div>
        );
      })}
    </div>
  );
};

export default WhiteLenders;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVD/whiteLenders/index.js